import { GET_MY } from '../../containers/App/constants';
import { fetchCompany } from '../Companies/actions';
import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_ADD_USER_ADDRESS,
  REQUEST_ADD_USER_TO_COMPANIES,
  REQUEST_COMPANIES,
  REQUEST_COUNTRIES,
  REQUEST_DELETE_USER_ADDRESS,
  REQUEST_DELETE_USER_FROM_COMPANY,
  REQUEST_UPDATE_USER_ADDRESS,
  REQUEST_USER,
  CREATE_USER,
  REQUEST_USER_AVATAR_UPDATE,
  REQUEST_USER_FILTER,
  REQUEST_USER_FILTER_RESET,
  UPDATE_USER_FILTERS,
  APPLY_USER_FILTERS,
  REQUEST_USER_PROPERTY_NAMES,
  REQUEST_USER_PROPERTY_UPDATE,
  REQUEST_USERS,
  EXPORT_DATA,
  GET_PERMISSIONS,
  UPDATE_PERMISSIONS,
  REQUEST_HOME_COMPANY_USERS,
  CHECK_USER_EMAIL,
  REQUEST_USER_UPDATE,
  REQUEST_WEBSITE_USER_FILTER,
  REQUEST_WEBSITE_USER,
  REQUEST_APPROVE_WEBSITE_USER,
  REQUEST_DISAPPROVE_WEBSITE_USER,
  REQUEST_WEBSITE_USER_PROPERTY_UPDATE,
  REQUEST_USER_HISTORY,
  UPDATE_USER_HISTORY_FILTER,
  UPDATE_USER_HISTORY_SEARCH_STRING,
} from './constants';

export function fetchUsers(offset = 0, limit = 100) {
  return {
    type: REQUEST_USER_FILTER,
  };
}

export function fetchUserPropertyNames() {
  return {
    type: GET_MY,
    id: REQUEST_USER_PROPERTY_NAMES,
    work: REQUEST_USER_PROPERTY_NAMES,
    path: `users/propertyNames`,
  };
}

export function fetchHomeCompanyUsers(callback) {
  return {
    type: GET_MY,
    id: REQUEST_HOME_COMPANY_USERS,
    work: REQUEST_HOME_COMPANY_USERS,
    callback,
    path: 'company/home-company/users',
  };
}

export function fetchUsersList(offset = 0, limit = FILTER_DEFAULT_LIMIT, text, companyId, callback) {
  // Transfered to new POST /users/getList endpoint
  // let queryParams = {
  //   offset,
  //   limit,
  //   text,
  //   requiredCompanyId: companyId,
  // };
  // queryParams = Object.entries(queryParams).reduce((acc, [key, value]) => {
  //   if (null !== value && undefined !== value) {
  //     acc[key] = value;
  //   }
  //   return acc;
  // }, {});
  //
  // const queryString = new URLSearchParams(queryParams).toString();

  const body = {};
  if (text) body.text = text;
  if (companyId) {
    body.filters = [
      {
        key: 'company',
        value: [companyId],
        type: 'multiple',
      },
    ];
  }

  return {
    type: GET_MY,
    id: REQUEST_USERS,
    work: REQUEST_USERS,
    callback,
    path: `users/getList`,
    post: body,
  };
}

export function fetchUser(userId, callback, options = {}) {
  if (typeof userId === 'string') {
    try {
      userId = parseInt(userId);
    } catch (e) {
      userId = null;
    }
  }
  if (!userId) {
    console.trace('userId not set trace');
    throw new Error('userId not set');
  }
  let work = options?.remarkCard ? `${REQUEST_USER}-remarkCard` : REQUEST_USER;
  if (options?.work) {
    work = REQUEST_USER + options?.work;
  }
  return {
    type: GET_MY,
    id: REQUEST_USER,
    userId: userId,
    callback,
    work: work,
    gate: REQUEST_USER + userId,
    path: `users/${userId}`,
  };
}

// export function fetchUserPropertyNames() {
//   return {
//     type: GET_MY,
//     id: REQUEST_USER_PROPERTY_NAMES,
//     work: REQUEST_USER_PROPERTY_NAMES,
//     path: `user-properties`,
//   };
// }

export function setUserProperty(userId, name, value, callback) {
  return {
    type: GET_MY,
    post: {
      userId,
      name,
      value,
    },
    userId,
    name,
    value,
    work: REQUEST_USER_PROPERTY_UPDATE,
    gate: REQUEST_USER_PROPERTY_UPDATE + userId + name,
    callback,
    path: `/users/${userId}/property`,
    putOnComplete: [fetchUser(userId)],
  };
}

export function setWebsiteProperty(userId, name, value, callback) {
  return {
    type: GET_MY,
    post: {
      userId,
      name,
      value,
    },
    userId,
    name,
    value,
    work: REQUEST_WEBSITE_USER_PROPERTY_UPDATE,
    gate: REQUEST_WEBSITE_USER_PROPERTY_UPDATE + userId + name,
    callback,
    path: `/website-admin/users/${userId}/property`,
    putOnComplete: [fetchWebsiteUser(userId)],
  };
}

export function saveFile(userId, propertyName, file, callback) {
  return {
    type: GET_MY,
    post: {
      userId,
      propertyName,
      file,
    },
    options: { formData: true },
    userId,
    name,
    work: REQUEST_USER_AVATAR_UPDATE,
    gate: REQUEST_USER_AVATAR_UPDATE + userId + name,
    callback,
    path: `/users/${userId}/property/file`,
    putOnComplete: [fetchUser(userId)],
  };
}

export function deleteUserProperty(propertyId, userId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_USER,
    gate: REQUEST_USER_PROPERTY_UPDATE + userId + name,
    delete: {},
    path: `users/${userId}/property/${propertyId}`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

export function createUser(user, callback, createIndividualCompany = false) {
  let path = 'users';
  if (createIndividualCompany ?? !user?.email_address) {
    user.email_address = null;
  }
  return {
    type: GET_MY,
    work: CREATE_USER,
    post: user,
    path,
    callback,
  };
}

export function fetchCountries() {
  return {
    type: GET_MY,
    id: REQUEST_COUNTRIES,
    work: REQUEST_COUNTRIES,
    path: `countries`,
  };
}

// TODO limit
export function fetchCompanies() {
  return {
    type: GET_MY,
    id: REQUEST_COMPANIES,
    work: REQUEST_COMPANIES,
    path: `company?limit=200`,
  };
}

export function addToCompany(userId, companyId, callback) {
  return {
    type: GET_MY,
    post: { userId },
    id: REQUEST_ADD_USER_TO_COMPANIES,
    work: REQUEST_ADD_USER_TO_COMPANIES,
    path: `company/${companyId}/user`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

export function deleteFromCompany(userId, companyId, callback) {
  return {
    type: GET_MY,
    delete: {},
    id: REQUEST_DELETE_USER_FROM_COMPANY,
    work: REQUEST_DELETE_USER_FROM_COMPANY,
    path: `company/${companyId}/user/${userId}`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

export function addAddress(userId, addressDto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_ADD_USER_ADDRESS,
    gate: REQUEST_ADD_USER_ADDRESS + userId,
    post: addressDto,
    path: `users/${userId}/address`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

export function updateAddress(userId, addressId, addressDto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_UPDATE_USER_ADDRESS,
    gate: REQUEST_UPDATE_USER_ADDRESS + userId + addressId,
    put: addressDto,
    path: `users/${userId}/address/${addressId}`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

export function exportData(userId, callback) {
  return {
    type: GET_MY,
    work: EXPORT_DATA,
    gate: EXPORT_DATA + userId,
    post: userId,
    path: `users/${userId}/export`,
    callback,
  };
}

export function deleteAddress(userId, addressId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_USER_ADDRESS,
    gate: REQUEST_DELETE_USER_ADDRESS + userId + addressId,
    delete: {},
    path: `users/${userId}/address/${addressId}`,
    putOnComplete: [fetchUser(userId)],
    callback,
  };
}

// USER_FILTERS

export function changeUserFilter(name, value) {
  return {
    type: REQUEST_USER_FILTER,
    name,
    value,
  };
}

export function applyUserFilters() {
  return {
    type: APPLY_USER_FILTERS,
  };
}

export function resetUserFilters() {
  return {
    type: REQUEST_USER_FILTER_RESET,
  };
}

export function updateUserFilter(propertyFilter, options) {
  return {
    type: UPDATE_USER_FILTERS,
    propertyFilter,
    ...options,
  };
}

export function changeUserPropertyFilter(propertyFilter, options) {
  return {
    type: REQUEST_USER_FILTER,
    propertyFilter,
    ...options,
  };
}

export function fetchPermissions() {
  return {
    type: GET_MY,
    id: GET_PERMISSIONS,
    work: GET_PERMISSIONS,
    path: `admin/permissions`,
  };
}

export function updatePermissions(userId, permissions) {
  return {
    type: GET_MY,
    work: UPDATE_PERMISSIONS,
    gate: UPDATE_PERMISSIONS + userId,
    put: { permissions },
    path: `admin/users/${userId}/permissions`,
    putOnComplete: [fetchUser(userId)],
  };
}

export function checkUserEmail(email_address, callback) {
  return {
    type: GET_MY,
    work: CHECK_USER_EMAIL,
    path: `users/find_by_email/${email_address}`,
    callback,
  };
}

export function updateUser(userId, dto, callback, options = {}) {
  let putOnComplete = [fetchUser(userId)];

  if (options?.companyId) [putOnComplete.push(fetchCompany(options?.companyId))];
  return {
    type: GET_MY,
    patch: dto,
    work: REQUEST_USER_UPDATE,
    gate: REQUEST_USER_UPDATE + userId + name,
    callback,
    path: `/users/${userId}`,
    putOnComplete,
  };
}

export function fetchWebsiteUsers(offset = 0, limit = 100) {
  return {
    type: REQUEST_WEBSITE_USER_FILTER,
  };
}

export function changeWebsiteUserFilter(name, value) {
  return {
    type: REQUEST_WEBSITE_USER_FILTER,
    name,
    value,
  };
}

export function fetchWebsiteUser(userId) {
  return {
    type: GET_MY,
    id: REQUEST_WEBSITE_USER,
    userId: userId,
    work: REQUEST_WEBSITE_USER,
    gate: REQUEST_WEBSITE_USER + userId,
    path: `website-admin/users/${userId}`,
  };
}

export function approveWebsiteUser(userId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_APPROVE_WEBSITE_USER,
    userId: userId,
    work: REQUEST_APPROVE_WEBSITE_USER,
    gate: REQUEST_APPROVE_WEBSITE_USER + userId,
    path: `website-admin/users/${userId}/approve`,
    post: {},
    callback,
    putOnComplete: [fetchWebsiteUser(userId)],
  };
}

export function disapproveWebsiteUser(userId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_DISAPPROVE_WEBSITE_USER,
    userId: userId,
    work: REQUEST_DISAPPROVE_WEBSITE_USER,
    gate: REQUEST_DISAPPROVE_WEBSITE_USER + userId,
    path: `website-admin/users/${userId}/disapprove`,
    post: {},
    callback,
    putOnComplete: [fetchWebsiteUser(userId)],
  };
}

export function approveWebsiteUserData(userId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_APPROVE_WEBSITE_USER,
    userId: userId,
    work: REQUEST_APPROVE_WEBSITE_USER,
    gate: REQUEST_APPROVE_WEBSITE_USER + userId,
    path: `website-admin/users/${userId}/approve-data`,
    post: {},
    callback,
    putOnComplete: [fetchWebsiteUser(userId)],
  };
}

export function disapproveWebsiteUserData(userId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_DISAPPROVE_WEBSITE_USER,
    userId: userId,
    work: REQUEST_DISAPPROVE_WEBSITE_USER,
    gate: REQUEST_DISAPPROVE_WEBSITE_USER + userId,
    path: `website-admin/users/${userId}/disapprove-data`,
    post: {},
    callback,
    putOnComplete: [fetchWebsiteUser(userId)],
  };
}

export function fetchUserHistory(userId, text = '', properties, callback) {
  let path = `/entity-history/user/${userId}?offset=0&limit=9999&order=desc`;
  if (text) {
    path += `&text=${text}`;
  }
  if (properties?.length) {
    properties?.forEach(p => {
      return (path += `&fields=${p?.value}`);
    });
  }
  return {
    type: GET_MY,
    id: REQUEST_USER_HISTORY,
    work: REQUEST_USER_HISTORY,
    gate: REQUEST_USER_HISTORY + userId,
    path: path,
    callback,
  };
}

export function updateUserHistoryFilter(properties = []) {
  return {
    type: UPDATE_USER_HISTORY_FILTER,
    properties,
  };
}

export function updateUserHistorySearchString(text) {
  return {
    type: UPDATE_USER_HISTORY_SEARCH_STRING,
    text,
  };
}
